import { type LinariaClassName } from "@linaria/core"
import { styled } from "@linaria/react"
import { observer } from "mobx-react-lite"


import { DiffComponent } from "@/components/Diff/Diff.tsx"
import { FileHeaderComponent } from "@/components/DiffFile/DiffFileHeader.tsx"
import { DiffFileModel } from "@/components/DiffFile/DiffFileModel.ts"
import { useModel } from "@/hooks/useModel.ts"
import { isNotNull } from "@/lib/std.ts"

import type { GitCommitChangeMin } from "@/components/DiffFile/DiffFileModel.ts"
import type { InlineDiff } from "@/lib/client/generated/TypeDefinitions.ts"
import type { Property } from "csstype"
import type { IObservableValue } from "mobx"


export const DiffFileComponent = observer((props: {
  file: GitCommitChangeMin
  diff: InlineDiff | null

  panelWidth?: () => Property.Width
  gutterWidth: IObservableValue<Property.Width>
  maxHeight?: Property.MaxHeight
  isCollapsible?: boolean
  close?: () => void
  className?: LinariaClassName
}) => {
  const vm = useModel(() => new DiffFileModel({
    file: props.file,
    diff: props.diff,

    isCollapsible: props.isCollapsible,
    close: props.close
  }), [props.file, props.diff, props.isCollapsible, props.close])

  return (
    <Container isCollapsed={vm.isCollapsed.get()} className={props.className}>
      <FileHeaderComponent vm={vm} />

      {!vm.isCollapsed.get() && (
        <Content>
          {isNotNull(vm.diff)
            ? (
              <DiffComponent
                data={vm.diff}
                panelWidth={props.panelWidth}
                gutterWidth={props.gutterWidth}
                maxHeight={props.maxHeight}
              />
            )
            : <Empty>No changes</Empty>}
        </Content>
      )}
    </Container>
  )
})

const Container = styled.div<{ isCollapsed: boolean }>`
  overflow: hidden;

  border: 1px solid var(--separator-color);
  border-radius: ${props => props.isCollapsed ? "8px" : "8px 8px 0 0"};
`

const Content = styled.div`
  overflow: auto;
`

const Empty = styled.div`
  background-color: var(--island-background-color);
  border-top: 1px solid var(--separator-color);
  padding: 8px 13px; /* Align to the chevron */
`
